import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core'
import { PaperlessCommercialInvoiceService } from '../paperless-commercial-invoice/services/paperless-commercial-invoice.service';

@Component({
  selector: 'upsc-file-selector',
  templateUrl: './file-selector.component.html',
  styleUrls: ['./file-selector.component.scss'],
})
export class FileSelectorComponent implements OnInit {

  @Input() label = 'worldShipUpload.chooseFile';
  @Input() fileTypes = '*/*';
  @Input() isMultiple = false;
  @Input() buttonClass = '';
  @Input() isDisabled = false;
  @Input() clearFileControl = false;
  @Input() letterheadImage;
  @Input() signatureImage;
  @Input() isLetterHead;
  @Input() isSignature;

  @Output() fileSelectionChanged: EventEmitter<FileList> = new EventEmitter<FileList>();
  @ViewChild('fileControl', { static: true }) fileControl: ElementRef;

  public letterHeadError: string;
  public signatureError: string;

  public showLetterHeadError = false;
  public showSignatureError = false;

  constructor(private translateService: TranslateService, 
    private paperlessCommercialInvoiceService: PaperlessCommercialInvoiceService,
  ) {
    this.translateService.instant(this.label);
    
  }

  public ngOnInit() {
    this.getCustomerDocumentsErrors();
  }

  public getCustomerDocumentsErrors(): void {
    this.paperlessCommercialInvoiceService.uploadCustomerDocumentsErrorMessage$.subscribe(
      (result) => {
        if (result?.includes('Letterhead') && result.includes('Signature')) {
          this.paperlessCommercialInvoiceService.uploadCustomerDocumentsLetterHeadAndSignatureErrorMessage$.next(result);
        }

        else if (result?.includes('Letterhead')) {
          this.showLetterHeadError = true;
          this.letterHeadError = result;
          this.signatureError = "";
          this.paperlessCommercialInvoiceService.uploadCustomerDocumentsLetterHeadAndSignatureErrorMessage$.next(null);
        }

        else if (result?.includes('Signature')) {
          this.showSignatureError = true;
          this.signatureError = result;
          this.letterHeadError = "";
          this.paperlessCommercialInvoiceService.uploadCustomerDocumentsLetterHeadAndSignatureErrorMessage$.next(null);
        }
      }
    )
  }

  public onFileSelectionChanged(event) {
    const files = event.target.files;
    if (!files || files.length === 0) {
      return;
    }

    this.fileSelectionChanged.emit(files);
    this.clearFileSelection();
  }

  private clearFileSelection() {
    if (this.clearFileControl) {
      this.fileControl.nativeElement.value = '';
    }
  }

}
